import React from 'react';
import { Box, Grid, SvgIcon, Typography } from '@mui/material';
import { useLocalStore } from '../local-store-provider/LocalStoreProvider.utils';
import { RevenueCalculatorStore } from '../revenue-calculator/RevenueCalculator.store';
import { toCurrency } from '../../utils/currency/currency.utils';
import { CurrencyCode } from '../../utils/currency/currency.constants';
import { DialTotal } from './dial-total/DialTotal';
import { observer } from 'mobx-react';
import { COLORS_LIGHTGREEN } from '../../App.constants';
import { ReactComponent as GrowthIcon } from './growth-icon.svg';
import { DialFieldMobile } from './dial-field-mobile/DialFieldsMobile';

export const DialsMobile: React.FC = observer(() => {
  const localStore = useLocalStore<RevenueCalculatorStore>();
  const dialsText = `With improvements to key metrics like billable utilization, bill rate and headcount— you could increase your annual revenue capacity by ${localStore.potentialRevenueCapacityWithUpdatesPercent}%`;

  return (
    <Grid
      container={true}
      justifyContent={'space-between'}
      direction={'column'}
    >
      <Grid
        item
        paddingX={6}
      >
        <Typography
          fontSize={'1.1rem'}
          fontWeight={'bolder'}
          marginBottom={4}
        >
          <Box
            display={'inline'}
            marginRight={2}
          >
            <SvgIcon
              style={{ transform: 'scale(1.5)' }}
              component={GrowthIcon}
              inheritViewBox
            />
          </Box>
          {dialsText}
        </Typography>
      </Grid>

      <DialFieldMobile
        inputValue={localStore.increaseAverageBillRate}
        onInputChange={localStore.updateIncreaseAverageBillRate}
        label={'Increase Average Bill Rate by'}
        subLabel={`${toCurrency(localStore.averageHourlyBillRate + localStore.increaseAverageBillRate, {
          fractionDigits: 2,
          currencyCode: CurrencyCode.USD,
        })} / Hr`}
        type={'currency'}
      />

      <DialFieldMobile
        inputValue={localStore.increaseBillableHeadcount}
        onInputChange={localStore.updateIncreaseBillableHeadcount}
        label={'Increase Billable Headcount By'}
        subLabel={`${localStore.billableEmployeeCount + localStore.increaseBillableHeadcount} Billable FTEs`}
        type={'percent'}
      />

      <DialFieldMobile
        inputValue={localStore.increaseBillableHeadcount}
        onInputChange={localStore.updateIncreaseBillableHeadcount}
        label={'Increase Billable Headcount By'}
        subLabel={`${localStore.billableEmployeeCount + localStore.increaseBillableHeadcount} Billable FTEs`}
        type={'none'}
      />

      <Box
        bgcolor={COLORS_LIGHTGREEN}
        padding={6}
        style={{ clipPath: 'polygon(50% 12%, 60% 0, 100% 0, 100% 100%, 0 100%, 0 0, 40% 0)' }}
      >
        <DialTotal
          fontSize={'1.2rem'}
          alignItems={'flex-start'}
          direction={'column'}
          text={'Revenue Capacity Today'}
          value={localStore.currentRevenuePotential}
        />
        <DialTotal
          fontSize={'1.2rem'}
          alignItems={'flex-start'}
          direction={'column'}
          text={'Potential Revenue Capacity'}
          value={localStore.potentialRevenueCapacityWithUpdates}
        />
        <Box
          width={'80%'}
          height={'1px'}
          bgcolor={'black'}
        />
        <DialTotal
          alignItems={'flex-start'}
          direction={'column'}
          text={'Increase / Decrease'}
          value={localStore.increaseDecreaseAmount}
          subText={`${localStore.potentialRevenueCapacityWithUpdatesPercent}%`}
          fontSize={'1.5rem'}
        />
      </Box>
    </Grid>
  );
});

DialsMobile.displayName = 'DialsMobile';
